import { Component, Input, OnInit, Output } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { CompanySetting } from '../../company-setting';
import { AccrualPeriodModel } from '../../data-services/accrual-period';
import { PtoPolicyAssignment } from '../../data-services/pto-policy/assignment';
import { PtoPolicySetup } from '../../data-services/pto-policy/setup';
import { IGroup } from '../../groups/IGroups';
import { Process, SelectItem } from '../../shared';
import { IUserInfo } from '../../user-info';

@Component({
    selector: 'ef-pto-policy-presenter',
    templateUrl: './pto-policy-presenter.component.html',
    styleUrls: ['./pto-policy-presenter.component.scss'],
    standalone: false
})
export class PtoPolicyPresenterComponent implements OnInit {
    @Input() process: Process;
    private PolicySetupSubject = new ReplaySubject<Array<PtoPolicySetup>>(1);
    private _policysetup: Array<PtoPolicySetup>;
    @Input() set policySetup(value: Array<PtoPolicySetup>) {
        this._policysetup = value;
        this.PolicySetupSubject.next(value);
    }
    get policySetup(): Array<PtoPolicySetup> {
        return this._policysetup;
    }

    private PolicyAssignmentSubject = new ReplaySubject<
        Array<PtoPolicyAssignment>
    >(1);
    private _policyassignment: Array<PtoPolicyAssignment>;
    @Input() set policyAssignment(value: Array<PtoPolicyAssignment>) {
        this._policyassignment = value;
        this.PolicyAssignmentSubject.next(value);
    }
    get policyAssignment(): Array<PtoPolicyAssignment> {
        return this._policyassignment;
    }

    private GroupsSubject = new ReplaySubject<Array<IGroup>>(1);
    private _groups: Array<IGroup>;
    @Input() set groups(value: Array<IGroup>) {
        this._groups = value;
        this.GroupsSubject.next(value);
    }
    get groups(): Array<IGroup> {
        return this._groups;
    }

    private AccrualPeriodSubject = new ReplaySubject<Array<AccrualPeriodModel>>(
        1
    );
    private _accrualperiods: Array<AccrualPeriodModel>;
    @Input() set accrualPeriods(value: Array<AccrualPeriodModel>) {
        this._accrualperiods = value;
        this.AccrualPeriodSubject.next(value);
    }
    get accrualPeriods(): Array<AccrualPeriodModel> {
        return this._accrualperiods;
    }

    private CompanySettingsSubject = new ReplaySubject<Array<CompanySetting>>(
        1
    );
    private _companysettings: Array<CompanySetting>;
    @Input() set companySettings(value: Array<CompanySetting>) {
        if (value && value.length > 0) {
            value = value.filter(x => x.SettingType == 'QBUpdateAccrual');
            value = value.map(x => ({
                ...x,
                SettingValue: x.SettingValue == '1' ? true : false
            }));
        }
        this._companysettings = value;
        this.CompanySettingsSubject.next(value);
    }
    get companySettings(): Array<CompanySetting> {
        return this._companysettings;
    }

    @Input() userInfo: IUserInfo;
    @Input() isQBO: boolean;

    @Output() SavePolicySetup = new ReplaySubject<any>(1);
    @Output() DeletePolicySetup = new ReplaySubject<any>(1);
    @Output() SavePolicyAssignment = new ReplaySubject<any>(1);
    @Output() UpdateCompanySetting = new ReplaySubject<any>(1);
    tabHeight: any;
    activeState = [true, true];

    @Input() accrualsFilterSelectItem: SelectItem[];

    constructor() {}

    ngOnInit(): void {
        this.handleOnOpen([0, 1]);
    }

    onSavePolicySetup($event) {
        this.SavePolicySetup.next($event);
    }
    onDeletePolicySetup($event) {
        this.DeletePolicySetup.next($event);
    }
    onSavePolicyAssignment($event) {
        this.SavePolicyAssignment.next($event);
    }
    onUpdateCompanySetting($event) {
        this.UpdateCompanySetting.next($event);
    }

    handleOnOpen($event: number[]) {
        const baseHeight = 60;
        this.tabHeight = `${
            baseHeight / ($event && $event.length ? $event.length : 1) - 1
        }vh`;
    }

    onSelectedChargeNumberTab($event) {
        if ($event === true) {
            this.activeState[1] = true;
            const event = [];
            if (this.activeState[0]) {
                event.push(0);
            }
            if (this.activeState[1]) {
                event.push(1);
            }
            setTimeout(() => {
                this.handleOnOpen(event);
            }, 0);
        }
    }
}
